export enum IntegrationStatus {
  reset = 'reset',
  processing = 'processing',
  pending = 'pending',
  error = 'error',
  complete = 'complete',
  resync = 'resync',
}
